const SCRAPED_ITEM_TYPES = {
  MENU: 'MENU',
  MENU_TITLE: 'MENU_TITLE',
  DISH: 'DISH',
}

export default SCRAPED_ITEM_TYPES
